export default __webpack_public_path__ + "fed1f9f1987f16c1bce260f6a9272c81.svg";